<template>

    <common-table :table-columns="tableColumns" :url="url" :operate="operate" :form-fields="formFields" :permission="permission" :searchs="searchs" ref="table"></common-table>
</template>

<script>
    import CommonTable from "@/components/CommonTable/CommonTable";
    export default {
        name: "LivePublishFlow",
        components: {CommonTable},
        data(){
            return {
                searchs:[
                    {
                        name: 'flowCode',
                        placeholder: '流程编码',
                        type: 'input'
                    },
                    {
                        name: 'flowName',
                        placeholder: '流程名称',
                        type: 'input'
                    },
                    {
                        name: 'platformType',
                        placeholder: '平台类型',
                        type: 'select',
                        selectValue: [{key:1, value:'抖音'},{key:2, value:'快手'}]
                    }
                ],
                permission:{
                    add: 'livePublishFlow:add',
                    update: 'livePublishFlow:update',
                    delete: 'livePublishFlow:delete',
                    deleteBatch: 'livePublishFlow:deleteBatch'
                },
                url: {
                    get: '/livePublish/flow/listByCondition',
                    add: '/livePublish/flow/add',
                    update: '/livePublish/flow/update',
                    delete: '/livePublish/flow/delete/',
                    delete_batch: '/livePublish/flow/deleteBatch'
                },
                tableColumns: [{
                    field: 'id',
                    label: 'Id',
                    show: true,
                    width: '75',
                }, {
                    field: 'flowCode',
                    label: '流程编码',
                    show: true,
                    width: '',
                }, {
                    field: 'flowName',
                    label: '流程名称',
                    show: true,
                    width: '',
                }, {
                    field: 'platformType',
                    label: '平台类型',
                    show: true,
                    width: '100',
                }, {
                    field: 'description',
                    label: '描述',
                    show: true,
                    width: '',
                }, {
                    field: 'remoteUrl',
                    label: '远程地址',
                    show: true,
                    width: '',
                }, {
                    field: 'enabled',
                    label: '状态',
                    show: true,
                    width: '80',
                }, {
                    field: 'sortOrder',
                    label: '排序',
                    show: true,
                    width: '80',
                }],
                operate: [
                    { name: 'edit', label: '编辑', type: 'text' },
                    { name: 'delete', label: '删除', type: 'text' }
                ],
                formFields: {
                    addTitle: '添加发布流程',
                    updateTitle: '修改发布流程',
                    model: [
                        { label: '流程编码', name: 'flowCode', type: 'input', required: true, placeholder: '请输入流程编码' },
                        { label: '流程名称', name: 'flowName', type: 'input', required: true, placeholder: '请输入流程名称' },
                        { label: '平台类型', name: 'platformType', type: 'select', required: true, placeholder: '请选择平台类型', selectValue: [{key:1, value:'抖音'},{key:2, value:'快手'}] },
                        { label: '描述', name: 'description', type: 'textarea', required: false, placeholder: '请输入描述' },
                        { label: '远程地址', name: 'remoteUrl', type: 'input', required: false, placeholder: '请输入远程地址' },
                        { label: '状态', name: 'enabled', type: 'switch', required: false, placeholder: '' },
                        { label: '排序', name: 'sortOrder', type: 'number', required: false, placeholder: '请输入排序' }
                    ]
                }
            }
        }
    }
</script>

<style scoped>

</style>
